<template>
   <div class="vertical-layout">
      <div id="containerbar" class="containerbar authenticate-bg">
        <!-- Start Container -->
        <div class="container">
         <router-view />
        </div>
        <!-- End Container -->
    </div>
   </div>
</template>

<script>
export default {
   
}
</script>